/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Academy_SubtitleInputs */

const en_academy_subtitle = /** @type {(inputs: Academy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your assigned courses`)
};

const ja_academy_subtitle = /** @type {(inputs: Academy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てられたコース`)
};

const fr_academy_subtitle = /** @type {(inputs: Academy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos cours assignés`)
};

const de_academy_subtitle = /** @type {(inputs: Academy_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre zugewiesenen Kurse`)
};

/**
* | output |
* | --- |
* | "Your assigned courses" |
*
* @param {Academy_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const academy_subtitle = /** @type {((inputs?: Academy_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Academy_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_academy_subtitle(inputs)
	if (locale === "ja") return ja_academy_subtitle(inputs)
	if (locale === "fr") return fr_academy_subtitle(inputs)
	return de_academy_subtitle(inputs)
});